module.exports = __webpack_public_path__ + "img/arrow.256bbf57.svg";